/**
 * Sanitize text for safe HTML rendering in print windows.
 * Escapes HTML special characters to prevent XSS.
 */
export const escapeHtml = (str) => {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

/**
 * Opens a print window with sanitized HTML content.
 * @param {string} title - Document title
 * @param {string} styles - CSS styles string
 * @param {string} bodyHtml - Pre-sanitized HTML body content
 */
export const openPrintWindow = (title, styles, bodyHtml) => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    alert('Please allow pop-ups to print.');
    return null;
  }
  const doc = printWindow.document;
  doc.open();
  doc.write('<!DOCTYPE html><html><head>');
  doc.write(`<title>${escapeHtml(title)}</title>`);
  doc.write(`<style>${styles}</style>`);
  doc.write('</head><body>');
  doc.write(bodyHtml);
  doc.write('</body></html>');
  doc.close();
  printWindow.focus();
  setTimeout(() => { printWindow.print(); }, 400);
  return printWindow;
};
